import React, { Fragment, useState } from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Sidebar from "../components/Navbar/Sidebar";
import { Link } from "react-router-dom";
import ReactPaginate from "react-paginate";
import Slider from "../components/Slider/Slider";
import { useEffect } from "react";
import { api } from "../services";
import { formatDate } from "../utils/validation";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return isMobile;
};

const News = () => {
  const isMobile = useIsMobile();
  const [newsData, setNewsData] = useState(null);
  const [filteredNews, setFilteredNews] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 3;
  const topNews = newsData ? newsData.slice(0, 4) : [];
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = filteredNews.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filteredNews.length / itemsPerPage);
  const [isSidebarOpened, setIsSidebarOpened] = useState(null);
  const [page, setPage] = useState(0);
  const [videoHref, setVideoHref] = useState();
  const [showVideo, setShowVideo] = useState(false)
  const [categories, setCategories] = useState([])
  const [tags, setTags] = useState([]);

  const responsive = [
    {
      itemsToShow: 1,
      maxWidth: 600,
    },
    {
      itemsToShow: 2,
      minWidth: 600,
    },
    {
      itemsToShow: 2,
      minWidth: 1200,
    },
    {
      itemsToShow: 3,
      minWidth: 1500,
    }
  ]

  const handlePageClick = (page) => {
    const newOffset = (page.selected * itemsPerPage) % newsData.length;
    setPage(page.selected);
    setItemOffset(newOffset);
  };

  const selectTag = (event, type) => {
    const tagName = event.target.innerHTML.toUpperCase();
    if (tagName === "AKTUELNO") setFilteredNews(newsData.slice(4))
    else type === "tags" ? setFilteredNews(newsData.filter(item => item.tags[0].title.toUpperCase() === tagName)) : setFilteredNews(newsData.filter(item => item.categories[0].title.toUpperCase() === tagName))

    setItemOffset(0);
    setPage(0);
  }


  const handleVideo = (event) => {
    const el = event.target;
    event.preventDefault();
    setVideoHref(el.href)
    setShowVideo(true);
  }

  useEffect(() => {
    api.news.getAllNews().then(res => {
      if (!res) return;
      setNewsData(res);
      setFilteredNews(res.slice(4));
    })
    api.categories.getNewsCategories().then(res => {
      if (!res) return;
      setCategories(res);
    })
    api.categories.getNewsTags().then(res => {
      if (!res) return;
      setTags(res)
    })
  }, [])

  useEffect(() => {
    document.querySelectorAll('.news-content .middle a ').forEach(item => {
      if (!item.href.includes('youtube')) return;
      item.addEventListener('click', handleVideo)
    })
    return () => {
      document.removeEventListener("click", handleVideo);
    };
  }, [filteredNews])

  return (
    <>
      {newsData && (
        <>
          <Header setIsSidebarOpened={setIsSidebarOpened} />
          <div className="container news_page news-content">
            <div className="">
              <h2 className="shadowtitle text-black ps-0">NOVOSTI</h2>
              <div className="text-start">
              </div>
              <div>
                <div className="row g-0 justify-content-center">
                  <div className="col-12 col-xl-8 col-xl-news-main middle order-1 order-xl-2 mb-3 mb-xl-0">
                    {topNews.map((item, key) => (
                      <div className="mb-4 pb-4 news-border-bottom" key={key}>
                        <Link className="text-decoration-none" to={`/novosti-detalji/${item.id}`}>
                          <div className="row g-0">
                            <div className="col-12 col-md-6">
                              <img src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.cover_image_small.src}`} alt="" className="w-100 rounded-4" />
                            </div>
                            <div className="col-12 col-md-6 ps-md-3 pt-3 pt-md-0 d-flex flex-column justify-content-center">
                              <div>
                                <h5 className="text-black" style={{fontWeight: 700, lineHeight: '141%'}}>{item.title}</h5>
                                <div className="news_detail_date mb-2">{formatDate(item.date)}</div>
                                <p className="text-muted mb-0">{item.description.replace(/<[^>]+>/g, '').substring(0, 190)} <span className="text-primary">&gt;&gt;&gt;</span></p>
                              </div>
                            </div>
                          </div>
                        </Link>
                      </div>
                    ))}
                  </div>


                  <div className="col-12 col-xl-4 col-xl-news-side right order-3 order-xl-3">
                    {!isMobile && <div className="row justify-content-center">
                      <div className="text-black mb-4 categories right-categories">
                        <h5 className="mb-3 news-category-title">Kategorije</h5>
                        <div className="d-inline-block me-3 mb-2" onClick={selectTag} role="button">Aktuelno</div>
                        {categories.map((item, key) => (
                          <div onClick={(e) => selectTag(e, "categories")} className="d-inline-block me-3 mb-2" role="button" key={key}>{item.title}</div>
                        ))}
                      </div>
                      <div className="row other-news-container mb-1 g-0">
                        {currentItems.map((item, key) => (
                          <div className="col-12 px-3" key={key}>
                            <Link to={`/novosti-detalji/${item.id}`} className="text-decoration-none other-news">
                              <div className="mx-auto d-flex flex-column justify-content-between other-news-container">
                                <div>
                                  <div className="image">
                                    {!!item.is_new && (
                                      <img src="/images/icons/new.svg" alt="" className="new_tag"></img>
                                    )}
                                    {!!item.is_coming_soon && (
                                      <img src="/images/icons/coming-soon.webp" alt="" className="new_tag p-1"></img>
                                    )}
                                    <img src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.cover_image_small.src}`} alt="" className="w-100 rounded-4"></img>
                                  </div>
                                  <h5 className="other-news-title">{item.title}</h5>
                                </div>
                                <div className="date mb-3 other-news-date">{formatDate(item.date)}</div>
                              </div>
                            </Link>
                          </div>
                        ))}
                        {filteredNews.length === 0 && (
                          <div className="no-data text-center">Trenutno nema novosti za odabranu kategoriju.</div>
                        )}
                      </div>
                      <ReactPaginate
                        className={`${filteredNews.length <= itemsPerPage ? "d-none" : ""}`}
                        breakLabel="..."
                        nextLabel=">"
                        onPageChange={handlePageClick}
                        pageRangeDisplayed={3}
                        pageCount={pageCount}
                        forcePage={page}
                        marginPagesDisplayed={1}
                        previousLabel="<"
                        renderOnZeroPageCount={null}
                        containerClassName="pagination justify-content-center"
                        activeClassName="active_page"
                        nextLinkClassName="pagination_items"
                        previousLinkClassName="pagination_items"
                        pageClassName="pagination_items"
                      />
                    </div>}
                  </div>



                  {isMobile && <div className="news-container other_news order-2 g-0">
                    <div className="text-black mb-4 categories text-center">
                      <h5 className="mb-3 news-category-title">Kategorije</h5>
                      <div className="d-inline-block me-3 mb-2" onClick={selectTag} role="button">Aktuelno</div>
                      {categories.map((item, key) => (
                        <div onClick={(e) => selectTag(e, "categories")} className="d-inline-block me-3 mb-2" role="button" key={key}>{item.title}</div>
                      ))}
                    </div>
                    <div className="mb-4">
                      {currentItems.slice(0).map((item, key) => (
                        <Link className="text-decoration-none" to={`/novosti-detalji/${item.id}`} key={key}>
                          <div className="description row g-0 mb-2 px-1">
                            {item.new && (
                              <img src="/images/icons/new.svg" alt="" className="new-icon"></img>
                            )}
                            {item.comingSoon && (
                              <img src="/images/icons/coming-soon.webp" alt="" className="coming-soon-icon"></img>
                            )}
                            <div className="col-6 image">
                              <img src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.cover_image_small.src}`} className="w-100 news-image-rounded" alt=""></img>
                              {item.tags.map((tag, key) => (
                                <Fragment key={key}>
                                  <div className="tag-container row g-0">
                                    <div className="tag px-1 me-2 mt-1 g-0">{tag.title.toUpperCase()}</div>
                                  </div>
                                </Fragment>
                              ))}
                            </div>
                            <div className="col-6 row g-0 justify-content-between ps-2">
                              <div className="other_news_title title-news">{item.title.toUpperCase()}</div>
                              <div className="other_news_date row g-0 align-items-end">{formatDate(item.date)}</div>
                            </div>
                          </div>
                        </Link>
                      ))}
                    </div>
                    {filteredNews.length === 0 && (
                      <div className="no_news text-center">Trenutno nema novosti za odabranu kategoriju.</div>
                    )}
                    <ReactPaginate
                      className={`${filteredNews.length <= itemsPerPage ? "d-none" : ""}`}
                      breakLabel="..."
                      nextLabel=">"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={3}
                      pageCount={pageCount}
                      forcePage={page}
                      marginPagesDisplayed={1}
                      previousLabel="<"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination justify-content-center"
                      activeClassName="active_page"
                      nextLinkClassName="pagination_items"
                      previousLinkClassName="pagination_items"
                      pageClassName="pagination_items"
                    />
                  </div>}
                </div>
              </div>
            </div>
            <Sidebar
              isSidebarOpened={isSidebarOpened}
              setIsSidebarOpened={setIsSidebarOpened}
            />
            {showVideo && (
              <div className="youtube_video">
                <iframe width="100%" height="100%" src={videoHref} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
              </div>
            )}
            <div onClick={() => setShowVideo(false)} className={`${showVideo ? "fullOverlay" : ""}`}></div>

          </div>
        </>
      )}
      <Footer />
    </>
  );
};

export default News;
